module.exports = __webpack_public_path__ + "img/crop5.b9daa918.png";